var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWingDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Wing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wings",
    transform: "translate(0.000000, 0.500000)",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33333333,0.533333333 C9.48060927,0.533333333 9.6,0.652724067 9.6,0.8 L9.6,2.54222222 L14.1333333,2.54222222 C14.2806093,2.54222222 14.4,2.66161296 14.4,2.80888889 L14.4,14.8 L16,14.8 L16,15.6 L0,15.6 L0,14.8 L0.8,14.8 L0.8,0.8 C0.8,0.652724067 0.919390733,0.533333333 1.06666667,0.533333333 L9.33333333,0.533333333 Z M8.64,1.46666667 L1.76,1.46666667 L1.76,14.8 L3.36,14.8 L3.36,10 L7.04,10 L7.04,14.8 L8.64,14.8 L8.64,1.46666667 Z M6.24,10.8 L4.16,10.8 L4.16,14.8 L6.24,14.8 L6.24,10.8 Z M13.44,3.46666667 L9.6,3.46666667 L9.6,14.8 L10.4,14.8 L10.4,11.6 L12.8,11.6 L12.8,14.8 L13.44,14.8 L13.44,3.46666667 Z M12,12.4 L11.2,12.4 L11.2,14.8 L12,14.8 L12,12.4 Z M12.8,7.98666667 L12.8,10.3866667 L10.4,10.3866667 L10.4,7.98666667 L12.8,7.98666667 Z M12.2,8.55 L11,8.55 L11,9.75 L12.2,9.75 L12.2,8.55 Z M7.84,5.86666667 L7.84,8.10666667 L5.6,8.10666667 L5.6,5.86666667 L7.84,5.86666667 Z M4.8,5.86666667 L4.8,8.10666667 L2.56,8.10666667 L2.56,5.86666667 L4.8,5.86666667 Z M7.12,6.65 L6.4,6.65 L6.4,7.37 L7.12,7.37 L7.12,6.65 Z M4.07,6.65 L3.35,6.65 L3.35,7.37 L4.07,7.37 L4.07,6.65 Z M12.8,4.78666667 L12.8,7.18666667 L10.4,7.18666667 L10.4,4.78666667 L12.8,4.78666667 Z M12.2,5.4 L11,5.4 L11,6.6 L12.2,6.6 L12.2,5.4 Z M4.8,2.82666667 L4.8,5.06666667 L2.56,5.06666667 L2.56,2.82666667 L4.8,2.82666667 Z M7.84,2.82666667 L7.84,5.06666667 L5.6,5.06666667 L5.6,2.82666667 L7.84,2.82666667 Z M4.02,3.6 L3.3,3.6 L3.3,4.32 L4.02,4.32 L4.02,3.6 Z M7.12,3.6 L6.4,3.6 L6.4,4.32 L7.12,4.32 L7.12,3.6 Z",
    id: "Combined-Shape",
    fill: "#6666666"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWingDark);
export default __webpack_public_path__ + "static/media/WingDark.1a87ec78.svg";
export { ForwardRef as ReactComponent };